<ng-container *transloco="let t">
  <div class="flex h-full flex-col">
    @if (atLeastOneImpacted()) {
      <p class="border-b border-gray-200 pb-4 text-sm text-gray-500">
        {{ t("tacos-strategy.impacted_ad_lines") }}
        <br />
        {{ t("tacos-strategy.please_review_changes") }}
      </p>

      <div class="flex w-full flex-1 flex-col gap-4 overflow-auto py-4">
        @for (creative of adLinesResult(); track creative.creativeId) {
          @if (creative.impacted) {
            <div class="text-lg font-medium text-gray-600">Creative #{{ creative.creativeId }}</div>
            @for (adLine of creative.adLines; track $index) {
              @if (adLine.impacted) {
                <div>
                  <div class="mb-2 text-gray-600">{{ t("sb-form-asins.ad_line") }} {{ $index + 1 }}</div>
                  <div class="flex items-end gap-2">
                    <div class="flex-1 rounded-lg border border-gray-200 p-3">
                      @for (a of adLine.asins; track a.asin) {
                        <div [class.bg-red-100]="a.deleted" [class.line-through]="a.deleted">{{ a.asin }}</div>
                      }
                    </div>
                    <IIcon name="arrowRight" class="size-8 text-gray-300" />
                    <div class="flex w-full flex-1 flex-col">
                      <div class="flex-1 rounded-lg border border-gray-200 p-3">
                        @for (a of adLine.asins; track a.asin) {
                          <div [class.invisible]="a.deleted">
                            {{ a.asin }}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              }
            }
          }
        }
      </div>
    } @else {
      <ISpinner [display]="true" />
    }

    <div class="flex justify-end gap-2 border-t border-gray-200 pt-4">
      <button iButton variant="ghost" (click)="onCancel()">
        {{ t("common.cancel") }}
      </button>
      <button
        iButton
        variant="destructive"
        [disabled]="!hasAtLeastOneAdLine()"
        [iTooltip]="noAdLineTooltip()"
        (click)="confirmDeletion()"
      >
        {{ t("common.delete") }}
      </button>
    </div>
  </div>
</ng-container>
